import * as stylex from '@stylexjs/stylex'
import { type IconButtonProps } from '../IconButton/IconButton'
import { IconButton } from '../IconButton/IconButton'
import { Visible, VisibleOff } from '../Icons'
import { colors } from '../tokens/colors.stylex'

interface ButtonToggleVisiblePasswordProps extends IconButtonProps {
  /** 密碼是否可見（true 顯示明文圖示、false 顯示遮蔽圖示） */
  show: boolean
}

const styles = stylex.create({
  root: {
    color: colors.grey500,
  },
})

/**
 * ButtonToggleVisiblePassword 密碼顯示/隱藏切換按鈕，
 * 根據 show 狀態切換眼睛圖示。通常搭配密碼輸入框使用。
 */
export function ButtonToggleVisiblePassword(props: ButtonToggleVisiblePasswordProps) {
  const { show, ...rest } = props
  return (
    <IconButton rootStyle={styles.root} {...rest}>
      {show ? <Visible /> : <VisibleOff /> }
    </IconButton>
  )
}
